import { FC, useState } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import Header from "../SubComponents/Header";
import { Formik, Form } from "formik";
import {
  Typography,
  Grid,
  Container,
  Box,
  InputAdornment,
  IconButton,
  useMediaQuery,
  Button,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import newimageauth from "../../assets/images/authbanner.png";
import Textfield from "../FormsUI/Textfield";
import ButtonSubmit from "../FormsUI/Button";
import view from "../../assets/images/view.svg";
import unview from "../../assets/images/unview.svg";
import AuthImage from "../SubComponents/AuthImage";
import useStyles from "../Styles/AuthStyles";
import { LoginFormValidation } from "../../helpers/Validations";
import { useContext } from "react";
import AuthContext from "../../store/Auth/AuthContext";
import GoogleLogin from "./GoogleLogin";
import DoubleLineText from "../SubComponents/DoubleLineText";
import { FcGoogle } from "react-icons/fc";
import useGoogleStyles from "./useGoogleStyles";
import Recaptcha from "./Recaptcha";

const isRemember = localStorage.getItem("rememberemail")!;

let formikValues = {
  email: "",
  password: "",
  remember: false,
  captcha: null,
};

if (isRemember) {
  formikValues = {
    email: isRemember,
    password: "",
    remember: false,
    captcha: null,
  };
}
const INITIAL_FORM_STATE = formikValues;

const LogIn: FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const googleClasses = useGoogleStyles();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const [captcha, setCaptcha] = useState<any>(null);
  const history = useHistory();

  const ref = queryParams.get('ref');

  const { isAuth, Login } = useContext<any>(AuthContext);

  if (isAuth) {
    if (ref) {
      history.push(ref);
    } else {
      history.push("/deals");
    }
  }

  const [values, setValues] = useState({
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };
  const View = () => {
    return <img src={view} className="img-fluid" alt="Gains" />;
  };
  const Unview = () => {
    return <img src={unview} className="img-fluid" alt="Gains" />;
  };

  return (
    <Box className={classes.authpages} component="section">
      <Header authPage loginPage />
      <>
        <Container fixed>
          <Grid container spacing={0}>
            <Grid className="borderleft" item md={5} sm={12}>
              <AuthImage image={newimageauth} />
            </Grid>
            <Grid className="borderleft" item md={7} sm={12}>
              <Box pl={isActive ? 0 : 7} pr={isActive ? 0 : 7}>
                {/* <Typography variant={isActive ? "h1" : "h2"} color="primary" className="mb-16">
                  Sign In
                </Typography> */}
                <Typography
                  variant={isActive ? "h1" : "h2"}
                  color="primary"
                  className="mb-16"
                >
                  Sign
                  <Typography
                    component="span"
                    variant={isActive ? "h1" : "h2"}
                    color="secondary"
                  >
                    {" "}
                    In
                  </Typography>
                </Typography>
                <Formik
                  enableReinitialize
                  initialValues={{
                    ...INITIAL_FORM_STATE,
                  }}
                  validationSchema={LoginFormValidation}
                  onSubmit={(values) => {
                    values = {
                      ...values,
                      email: values.email.toLowerCase(),
                      captcha: captcha,
                    };
                    Login(values);
                  }}
                >
                  <Form>
                    <Grid container spacing={isActive ? 2 : 3}>
                      <Grid item md={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          color="secondary"
                          className="fw-normal"
                        >
                          Email
                        </Typography>
                        <Textfield
                          name="email"
                          placeholder="Email"
                          margin="dense"
                          required
                        />
                      </Grid>
                      <Grid className="pb-0" item md={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          color="secondary"
                          className="fw-normal"
                        >
                          Password
                        </Typography>
                        <Textfield
                          name="password"
                          type={values.showPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          required
                          margin="dense"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                  color="secondary"
                                >
                                  {values.showPassword ? <Unview /> : <View />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid
                        className={
                          "align-self-center " + isActive ? "mb-8" : ""
                        }
                        item
                        xs={12}
                      >
                        <NavLink
                          className="text-decoration-none"
                          to="./recover-password"
                        >
                          <Typography
                            align="right"
                            variant="body1"
                            color="secondary"
                            className="fw-bold"
                          >
                            Forgot Password?
                          </Typography>
                        </NavLink>
                      </Grid>
                    </Grid>
                    <Grid
                      className="align-self-center pt-10"
                      item
                      md={6}
                      xs={6}
                    >
                      <Recaptcha setCaptcha={setCaptcha} />
                    </Grid>
                    <Grid
                      container
                      className="mt-12"
                      lg={6}
                      xs={12}
                      direction="column"
                      spacing={2}
                    >
                      <Grid item>
                        <ButtonSubmit disabled={!captcha} fullWidth>
                          Sign In
                        </ButtonSubmit>
                      </Grid>
                      <Grid item>
                        <DoubleLineText text={"OR"} />
                      </Grid>
                      <Grid item>
                        <div
                          className={googleClasses.googleLoginContainer}
                          style={{ width: "100%" }}
                        >
                          <GoogleLogin />
                          <div>
                            <Button
                              variant="contained"
                              startIcon={<FcGoogle />}
                              fullWidth
                              className={googleClasses.customGoogle}
                              style={{
                                top: isActive ? 7 : 0,
                              }}
                            >
                              Continue With Google
                            </Button>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </Form>
                </Formik>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </>
    </Box>
  );
};

export default LogIn;
